export default __webpack_public_path__ + "static/media/success-purchase-image.785f3b0f.png";